import { useParentPostMessage } from '@yes.technology/react-toolkit'
import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { isEmbedded } from 'shared/utils/iframe'
import { Metadata } from 'token/shared/types'

const buildTaskScreenUrl = (processUuid?: string) => {
  const taskScreenUrl = window.taskScreenUrl
  if (!taskScreenUrl) return null

  if (processUuid) {
    return `${taskScreenUrl}?process-uuid=${processUuid}`
  }
  return taskScreenUrl
}

const useGateway = () => {
  const navigate = useNavigate()
  const { postMessage } = useParentPostMessage()

  const navigateToForwardURL = useCallback(
    (metadata?: Metadata) => {
      if (!metadata?.forward_url) return false

      if (isEmbedded()) {
        postMessage({
          type: 'redirect',
          url: metadata.forward_url
        })

        return true
      }

      if (/^https?:\/\//.test(metadata.forward_url)) {
        window.location.href = metadata.forward_url
      } else {
        navigate(metadata.forward_url)
      }

      return true
    },
    [navigate]
  )

  const navigateToTaskScreen = useCallback(
    (processUuid?: string) => {
      const url = buildTaskScreenUrl(processUuid)
      if (!url) return

      if (isEmbedded()) {
        postMessage({
          type: 'redirect',
          url
        })

        return
      }

      window.location.href = url
    },
    [postMessage]
  )

  return { navigateToForwardURL, navigateToTaskScreen }
}

export default useGateway
